document.addEventListener('DOMContentLoaded', function () {
    function initEnquireModal() {
        let enquireModal = document.getElementById('enquireModal');
        let enquireOptionsModal = document.getElementById('enquireOptionsModal');
        let consultationModal = document.getElementById('consultationModal');

        let openEnquireBtn = document.querySelectorAll('#openEnquireModal');
        let openEnquireOptionsBtn = document.querySelectorAll('#openEnquireOptionsModal');
        let openConsultationBtn = document.querySelectorAll('#openConsultationModal');

        // OPEN ENQUIRE MODAL
        openEnquireOptionsBtn.forEach((button) => {
            button.addEventListener('click', function () {
                const quickBuy = this.closest('.quick-buy-modal__content');

                if (quickBuy) {
                    // Quick Buy modal version
                    enquireOptionsModal =
                        quickBuy.querySelector('#enquireOptionsModal');
                }
                enquireOptionsModal.style.display = 'block';
                document.body.style.overflow = 'hidden';
            });
        });

        // OPEN ENQUIRE MODAL
        if (openEnquireBtn) {
            openEnquireBtn.forEach((button) => {
                button.addEventListener('click', function () {
                    const quickBuy = this.closest('.quick-buy-modal__content');

                    if (quickBuy) {
                        // Quick Buy modal version
                        enquireModal = quickBuy.querySelector('#enquireModal');
                    }
                    enquireModal.style.display = 'block';
                    document.body.style.overflow = 'hidden';
                    document.getElementById('enquirySuccess').style.display = 'none';
                    document.getElementById('consultationError').style.display = 'none';
                });
            });
        }

        // OPEN CONSULTATION MODAL
        if (openConsultationBtn) {
            openConsultationBtn.forEach((button) => {
                button.addEventListener('click', function () {
                    const quickBuy = this.closest('.quick-buy-modal__content');
                    if (quickBuy) {
                        // Quick Buy modal version
                        consultationModal =
                            quickBuy.querySelector('#consultationModal');
                    }
                    consultationModal.style.display = 'block';
                    document.body.style.overflow = 'hidden';
                });
            });
        }

        // CLOSE MODALS
        document.querySelectorAll('.close-modal').forEach(function (btn) {
            btn.addEventListener('click', function () {

                const visibleModal = this.closest('.custom-modal');

                if (visibleModal) {
                    visibleModal.style.display = 'none';
                }
                document.body.style.overflow = 'auto';
            });
        });

        // CLOSE ON OUTSIDE CLICK
        window.addEventListener('click', function (e) {

            if (e.target === enquireOptionsModal) {
                enquireOptionsModal.style.display = 'none';
                document.body.style.overflow = 'auto';
            }

            if (e.target === enquireModal) {
                enquireModal.style.display = 'none';
                document.body.style.overflow = 'auto';
            }

            if (e.target === consultationModal) {
                consultationModal.style.display = 'none';
                document.body.style.overflow = 'auto';
            }
        });

        // ALLOW ONLY TOMORROW TO NEXT 15 DAYS
        const consultationDateTime = document.getElementById('consultationDateTime');

        if (consultationDateTime) {

            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            tomorrow.setHours(0, 0, 0, 0);

            const maxDate = new Date();
            maxDate.setDate(maxDate.getDate() + 15);
            maxDate.setHours(23, 59, 0, 0);

            // FORMAT FUNCTION
            function formatDateTimeLocal(date) {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');

                return `${year}-${month}-${day}T${hours}:${minutes}`;
            }

            // SET MIN & MAX
            consultationDateTime.min = formatDateTimeLocal(tomorrow);
            consultationDateTime.max = formatDateTimeLocal(maxDate);
        }

        const forms = document.querySelectorAll('#consultationForm');

        forms?.forEach((form) => {
            form?.addEventListener('submit', async function (e) {
                e.preventDefault();
                e.stopPropagation();

                const submitBtn = form.querySelector('button[type="submit"]');

                form.querySelector('#consultationSuccess').style.display = 'none';
                form.querySelector('#consultationError').style.display = 'none';
                form.querySelector('#consultationErrorTest').style.display = 'none';

                if (form.consultation_first_name.value.toLowerCase().indexOf('test') !== -1 || form.consultation_last_name.value.toLowerCase().indexOf('test') !== -1 || form.consultation_email.value.toLowerCase().indexOf('test') !== -1) {
                    form.querySelector('#consultationErrorTest').style.display = 'block';
                    return false;
                }

                submitBtn.disabled = true;
                submitBtn.innerText = 'Submitting...';

                try {

                    // REPLACE WITH YOUR API URL
                    const response = await fetch('https://lukeazzopardi.eqserver.net/api/customer', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            is_from_enquiry: false,
                            first_name: form.consultation_first_name.value,
                            last_name: form.consultation_last_name.value,
                            email: form.consultation_email.value,
                            custom_properties: {
                                // consultation_datetime: form.consultation_datetime.value,
                                consultation_product_title: form.consultation_product_title.value,
                                consultation_product_link: form.consultation_product_link.value
                            }
                        })
                    });

                    if (!response.ok) {
                        throw new Error('Request failed');
                    }

                    form.querySelector('#consultationSuccess').style.display = 'block';

                    form.reset();

                } catch (error) {

                    console.error(error);

                    form.querySelector('#consultationError').style.display = 'block';

                } finally {

                    submitBtn.disabled = false;
                    submitBtn.innerText = 'Book Consultation';

                }
            });
        });

        const enquiryForm = document.getElementById('enquiryForm');

        document.querySelectorAll('#enquiryForm').forEach((enquiryForm) => {

            const phoneInput = enquiryForm.querySelector('[name="enquire_mobile_number"]');

            if (!phoneInput) return;

            const iti = window.intlTelInput(phoneInput, {
                separateDialCode: false,
                nationalMode: false,
                initialCountry: 'auto',
                autoPlaceholder: 'aggressive',
                loadUtils: () =>
                    import("https://cdn.jsdelivr.net/npm/intl-tel-input@25/build/js/utils.js")
            });

            // Store instance on the form
            enquiryForm._iti = iti;

        });

        // console.log('iti', iti)
        // Sync phone country with country dropdown
        document.querySelectorAll('[name="enquire_country"]').forEach(countrySelect => {
            countrySelect.addEventListener('change', function () {
                const form = this.closest('form');
                const iti = form._iti;
                const iso = this.options[this.selectedIndex]?.dataset?.iso;
                if (iti && iso) {
                    iti.setCountry(iso);
                }
            });

        });

        document.querySelectorAll('#enquiryForm').forEach(enquiryForm => {
            enquiryForm?.addEventListener('submit', async function (e) {

                e.preventDefault();
                e.stopPropagation();

                const submitBtn = enquiryForm.querySelector('button[type="submit"]');
                enquiryForm.querySelector('#enquirySuccess').style.display = 'none';
                enquiryForm.querySelector('#enquiryError').style.display = 'none';
                enquiryForm.querySelector('#enquiryErrorTest').style.display = 'none';
                enquiryForm.querySelector('#enquiryErrorPhoneNumberDigit').style.display = 'none';
                enquiryForm.querySelector('#enquiryErrorPhoneNumberValid').style.display = 'none';

                if (enquiryForm.enquire_first_name.value.toLowerCase().indexOf('test') !== -1 || enquiryForm.enquire_last_name.value.toLowerCase().indexOf('test') !== -1 || enquiryForm.enquire_email.value.toLowerCase().indexOf('test') !== -1 || enquiryForm.enquire_message.value.toLowerCase().indexOf('test') !== -1) {
                    enquiryForm.querySelector('#enquiryErrorTest').style.display = 'block';
                    return false;
                }

                const mobileNumber = enquiryForm.enquire_mobile_number.value.trim();
                if (!/^\d+$/.test(mobileNumber.replaceAll(' ', ''))) {
                    enquiryForm.querySelector('#enquiryErrorPhoneNumberDigit').style.display = 'block';
                    return false;
                }

                const iti = enquiryForm._iti;
                if (!iti.isValidNumber()) {

                    enquiryForm.querySelector('#enquiryErrorPhoneNumberValid').style.display = 'block';

                    return false;
                }

                // Full international number
                const fullPhoneNumber = iti.getNumber();

                submitBtn.disabled = true;
                submitBtn.innerText = 'Submitting...';

                const prefix_mb = '+' + document.querySelector('.iti__country[aria-selected="true"]').dataset.dialCode;

                try {
                    const response = await fetch('https://lukeazzopardi.eqserver.net/api/customer', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            is_from_enquiry: true,
                            first_name: enquiryForm.enquire_first_name.value,
                            last_name: enquiryForm.enquire_last_name.value,
                            email: enquiryForm.enquire_email.value,
                            phone_number: fullPhoneNumber,
                            custom_properties: {
                                message: enquiryForm.enquire_message.value,
                                enquire_product_title: enquiryForm.enquire_product_title.value,
                                enquire_product_link: enquiryForm.enquire_product_link.value,
                                country: enquiryForm.enquire_country.value,
                            }
                        })
                    });

                    if (!response.ok) {
                        throw new Error('Request failed');
                    }

                    enquiryForm.querySelector('#enquirySuccess').style.display = 'block';

                    enquiryForm.reset();

                } catch (error) {

                    console.error(error);

                    enquiryForm.querySelector('#enquiryError').style.display = 'block';

                } finally {

                    submitBtn.disabled = false;
                    submitBtn.innerText = 'Submit Enquiry';

                }

            });
        });
    }
    initEnquireModal();
    window.initEnquireModal = initEnquireModal;
});